// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2mLud","name":"ConsentHeader_name__-Mn-l","birthday":"ConsentHeader_birthday__1gzSs","skeleton":"ConsentHeader_skeleton__1ROnT"};